import {JobWarrantyRegistrationStatusApiDto} from "../../api/model/rest";

export default class JobWarrantyRegistrationStatus {

	constructor(public readonly label: string,
		public readonly value: string) {}

	static fromJson(json: JobWarrantyRegistrationStatusApiDto): JobWarrantyRegistrationStatus {
		return new JobWarrantyRegistrationStatus(json.label, json.value);
	}
}
